"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var classnames_1 = __importDefault(require("classnames"));
var use_long_press_1 = require("use-long-press");
var Button_less_1 = __importDefault(require("./Button.less"));
var safeInternalPath_1 = require("stremio/router/safeInternalPath");
var playerRoutes_1 = require("stremio/caroline/playback/playerRoutes");
var playerSelection_1 = require("stremio/caroline/playback/playerSelection");
var externalLinks_1 = require("stremio/caroline/navigation/externalLinks");
var Button = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var as = _a.as, className = _a.className, href = _a.href, disabled = _a.disabled, children = _a.children, onLongPress = _a.onLongPress, onDoubleClick = _a.onDoubleClick, handleClick = _a.onClick, props = __rest(_a, ["as", "className", "href", "disabled", "children", "onLongPress", "onDoubleClick", "onClick"]);
    var longPress = (0, use_long_press_1.useLongPress)(onLongPress, { detect: use_long_press_1.LongPressEventType.Pointer });
    var to = typeof href === 'string' && href.startsWith('#/') && typeof props.download !== 'string' ? (_b = (0, safeInternalPath_1.safeInternalPath)((0, playerRoutes_1.canonicalPlayerLink)(href).slice(1))) !== null && _b !== void 0 ? _b : '/' : null;
    var component = to !== null ? react_router_dom_1.Link : typeof href === 'string' && href.length > 0 ? 'a' : as || 'div';
    var onKeyDown = (0, react_1.useCallback)(function (event) {
        if (typeof props.onKeyDown === 'function') {
            props.onKeyDown(event);
        }
        if ((component === 'button' || component === 'div') && (event.key === 'Enter' || event.key === ' '))
            event.stopPropagation();
        if (event.key === 'Enter' || (component === 'div' && event.key === ' ')) {
            event.preventDefault();
            if (disabled || (0, classnames_1.default)(className).split(' ').includes('disabled'))
                return;
            // @ts-expect-error: Property 'buttonClickPrevented' does not exist on type 'KeyboardEvent'.
            if (!event.nativeEvent.buttonClickPrevented) {
                event.currentTarget.click();
            }
        }
    }, [props.onKeyDown, component, disabled, className]);
    var onMouseDown = (0, react_1.useCallback)(function (event) {
        if (typeof props.onMouseDown === 'function') {
            props.onMouseDown(event);
        }
        // @ts-expect-error: Property 'buttonBlurPrevented' does not exist on type 'MouseEvent'.
        if (!event.nativeEvent.buttonBlurPrevented) {
            event.preventDefault();
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }
    }, [props.onMouseDown]);
    var target = props.target;
    var onClick = (0, react_1.useCallback)(function (event) {
        handleClick === null || handleClick === void 0 ? void 0 : handleClick(event);
        if (!event.defaultPrevented && event.button === 0 && !event.ctrlKey && !event.metaKey &&
            !event.altKey && !event.shiftKey && target !== '_blank' && to !== null && typeof href === 'string') {
            (0, playerSelection_1.preparePlayerNavigation)(href);
        }
    }, [handleClick, target, to, href]);
    // Do not render dormant legacy destinations as clickable/context-menu links.
    if ((0, externalLinks_1.isStremioExternalUrl)(href))
        return null;
    return (0, react_1.createElement)(component, __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ tabIndex: 0 }, props), (component === 'button' ? { type: 'button', disabled: disabled || (0, classnames_1.default)(className).split(' ').includes('disabled') } : {})), (component === 'div' && !props.role ? { role: 'button' } : {})), { 'aria-label': props['aria-label'] || props.title, 'aria-disabled': disabled || (0, classnames_1.default)(className).split(' ').includes('disabled') || undefined, ref: ref, className: (0, classnames_1.default)(className, Button_less_1.default['button-container'], { 'disabled': disabled }), href: to !== null ? "#".concat(to) : href, onClick: onClick }), (props.target === '_blank' ? { rel: 'noopener noreferrer' } : {})), (to !== null ? { to: to } : {})), { onKeyDown: onKeyDown, onMouseDown: onMouseDown, onDoubleClick: onDoubleClick }), longPress()), children);
});
exports.default = Button;
